import autosize from 'autosize';

document.addEventListener("DOMContentLoaded", function() {
    autosize(document.querySelectorAll('textarea'));
});